export const NOTES_REQUEST = 'NOTES_REQUEST';
export const NOTES_SUCCESS = 'NOTES_SUCCESS';
export const NOTES_FAIL = 'NOTES_FAIL';

export const NOTES_SELECT = 'NOTES_SELECT';
export const NOTES_SELECTALL = 'NOTES_SELECTALL';

export const NOTESDEL_REQUEST = 'NOTESDEL_REQUEST';
export const NOTESDEL_SUCCESS = 'NOTESDEL_SUCCESS';
export const NOTESDEL_FAIL = 'NOTESDEL_FAIL';



// WEBPACK FOOTER //
// ./src/constants/Notes.js